import React from 'react'
import PropTypes from 'prop-types'
import './FileCell.css'
import FilePreviewAndDownload from "../filePreviewAndDownload";

export const FileCell = ({ file, language, groupModel, accessId }) => (
    <div
        className="DataTable-FileCell"
        style={{ marginRight: '10px', display: 'flex', alignItems: 'center', height: '100%' }}
        onClick={(event) => {
            event.stopPropagation()
        }}
    >
        <FilePreviewAndDownload
            key={file.id}
            file={file}
            language = {language}
            groupModel={groupModel}
            accessId={accessId}
        />
    </div>
)

FileCell.propTypes = {
    file: PropTypes.any.isRequired,
}

export default FileCell
